module.exports = __webpack_public_path__ + "static/gilead-6e9eb48ce7289967ec4bf4930104b916.jpg";